// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { RepeatableItemValue, TextUtils } from '@fulcrumapp/fulcrum-core';
import { XIcon, ForwardIcon } from '../../icons';
import Collapse from '../../shared/collapse';
import Dialog from '../../shared/dialog';

export default class RepeatableListItemView extends React.Component {
  static propTypes = {
    editing: PropTypes.bool.isRequired,
    item: PropTypes.instanceOf(RepeatableItemValue).isRequired,
    onClick: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    highlighted: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      showDeleteConfirmation: false,
    };
  }

  render() {
    const { styles } = RepeatableListItemView;
    const { highlighted } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={css(styles.container)}
        style={{ backgroundColor: highlighted ? 'rgba(0, 166, 255, 0.1)' : '#fff' }}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <Collapse
          open={this.props.editing}
          dimension="width"
          className={styles.collapseContainer}
        >
          <span className={css(styles.removeContainer)}>
            <a
              className={css(styles.remove)}
              onClick={this.handleDeleteItem}
            >
              <XIcon />
            </a>
          </span>
        </Collapse>
        {this.renderTitle()}
        {this.renderAccessory()}
        <Dialog
          negative="Cancel"
          positive="Yes, Delete"
          title="Confirmation"
          show={this.state.showDeleteConfirmation}
          onNegativeClick={this.handleDeleteCancelClick}
          onPositiveClick={this.handleDeleteOkayClick}
        >
          <div>
            <p>Are you sure you want to delete this item?</p>
          </div>
        </Dialog>
      </div>
    );
  }

  renderTitle() {
    const { styles } = RepeatableListItemView;

    let { displayValue } = this.props.item;
    let classes = styles.title;

    if (TextUtils.isEmpty(displayValue)) {
      classes = css(classes, styles.untitled);
      displayValue = 'Untitled';
    }

    return (
      <div className={classes}>
        {displayValue}
      </div>
    );
  }

  renderAccessory() {
    const { styles } = RepeatableListItemView;

    return (
      <div className={css(styles.accessory)}>
        <span className={css(styles.accessoryLabel)}>View</span>
        <ForwardIcon className={styles.accessoryIcon} />
      </div>
    );
  }

  handleDeleteItem = (event) => {
    this.setState({ showDeleteConfirmation: true });
    event.preventDefault();
    event.stopPropagation();
  };

  handleDeleteCancelClick = (event) => {
    this.setState({ showDeleteConfirmation: false });
  };

  handleDeleteOkayClick = (event) => {
    this.setState({ showDeleteConfirmation: false });
    this.props.onDelete(this.props.item);
  };

  handleClick = () => {
    this.props.onClick(this.props.item);
  };

  handleMouseEnter = (event) => {
    this.props.onMouseEnter(this.props.item);
  };

  handleMouseLeave = (event) => {
    this.props.onMouseLeave(this.props.item);
  };
}

const styles = cssInJS({
  container: {
    borderBottom: THEME.fieldBorderLight,
    backgroundColor: '#fff',
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',

    ':hover': {
      backgroundColor: '#f1f1f1',
    },
  },

  collapseContainer: {
    verticalAlign: 'top',
  },

  removeContainer: {
    width: 36,
    height: 36,
    display: 'inline-block',
    verticalAlign: 'top',
    paddingRight: 0,
  },

  remove: {
    padding: 10,
    width: 36,
    height: 36,
    display: 'inline-block',

    ':hover': {
      fill: '#f00',
      color: '#f00',
    },
  },

  title: {
    fontWeight: 'bold',
    padding: '10px 80px 10px 10px',
    fontSize: 13,
  },

  untitled: {
    fontStyle: 'italic',
  },

  accessory: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    fontSize: 12,
    fontWeight: 'bold',
    height: 36,
  },

  accessoryLabel: {
    display: 'inline-block',
    verticalAlign: 'top',
    height: 36,
    paddingTop: 11,
  },

  accessoryIcon: {
    display: 'inline-block',
    height: 36,
    width: 36,
    padding: 10,
  },
});

RepeatableListItemView.styles = styles;
